import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from './selectLocation';
import { selectIsSuburbanListing } from '../jsonQuery';

export const selectHasHighways = createSelector(
  [selectLocation, selectIsSuburbanListing],
  (currentLocation, isSuburban) => {
    if (currentLocation === 'spb_lo') {
      return false;
    }

    return (currentLocation === 'moscow_mo' || currentLocation.hasHighway) && isSuburban;
  },
);
